module.exports = __webpack_public_path__ + "img/close.c714e8c2.png";